module.exports = __webpack_public_path__ + "src/assets/img/letidor.5a921dcf.jpg";